export default "__VITE_PUBLIC_ASSET__5ffbf88a__"